import httpClient from 'shared/lib/httpClient';

export const forgotPassword = async (formData) => {
  const response = await httpClient.post('/forgot-password', formData);
  return response?.data;
};
